/**
 * Dokumente
 * Die API ermöglicht es die vorhanden Ablageorte (Ordner) zu laden. In den Ablageorten kann der Buchhalter mit Hilfe von ADNOVA+ Dokumente für den Mandanten hochladen, welche nicht buchhaltungsrelevant sind. Dokumente sind immer automatisch als \'ungelesen\' markiert. <br><br> Innerhalb der Ablageorte können Dokumente geladen, gesucht, gezählt als gelesen markiert und heruntergeladen werden. 
 *
 * The version of the OpenAPI document: ${project.version}
 * Contact: support@landdata.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PageableDokumentAllOfDTO } from './pageable-dokument-all-of-dto';
import { BasePageableDTO } from './base-pageable-dto';


/**
 * Gibt das OffSet, Limit und die Sortierung für das Abrufen von Dokumenten an.<br> 
 */
export interface PageableDokumentDTO { 
    /**
     * Wird bei GET-Funktionen genutzt, um anzugeben, wie viele Werte übersprungen werden sollen.
     */
    offset?: number;
    /**
     * Wird bei GET-Funktionen genutzt, um die Anzahl der zurückgegebenen Werte zu begrenzen
     */
    limit?: number;
    sorting?: Array<PageableDokumentDTOSortingEnum>;
}
export enum PageableDokumentDTOSortingEnum {
    Bezeichnungasc = 'BEZEICHNUNGASC',
    Bezeichnungdesc = 'BEZEICHNUNGDESC',
    Erstelltasc = 'ERSTELLTASC',
    Erstelltdesc = 'ERSTELLTDESC',
    Geaendertasc = 'GEAENDERTASC',
    Geaendertdesc = 'GEAENDERTDESC',
    Jahrasc = 'JAHRASC',
    Jahrdesc = 'JAHRDESC',
    Dateigroesseasc = 'DATEIGROESSEASC',
    Dateigroessedesc = 'DATEIGROESSEDESC',
    Bearbeiterasc = 'BEARBEITERASC',
    Bearbeiterdesc = 'BEARBEITERDESC'
};



